"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMediaRight;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIMediaRight(props) {
  var className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["className"]);
  return _react.default.createElement("div", Object.assign({}, rest, {
    className: (0, _classnames.default)('private-media__item', 'private-media__item--right', className)
  }));
}

UIMediaRight.displayName = 'UIMediaRight';
UIMediaRight.propTypes = {
  children: _propTypes.default.node
};
module.exports = exports.default;